import { render, staticRenderFns } from "./ProductDetailModal.vue?vue&type=template&id=98a9c178&scoped=true"
import script from "./ProductDetailModal.vue?vue&type=script&lang=js"
export * from "./ProductDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailModal.vue?vue&type=style&index=0&id=98a9c178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a9c178",
  null
  
)

export default component.exports